import { useHeaderSearchTypeSelection } from '@upright/ui/common/upright/model/output/search/header-search/use-header-search-type';
import { useSuggestions } from '@upright/ui/common/upright/model/output/search/header-search/use-suggestions';
import { getOptionIcon } from '@upright/ui/common/upright/model/output/search/option-icon';
import styled from 'styled-components';
import { getModelEntityUrl } from '../../../../../../untidy/urls';
import { Item, ItemLink, MenuTitleSmall } from '../shared-menus';

interface Props {
  close: () => void;
}

const Root = styled.div``;
export function ExampleSearchesBlock(props: Props) {
  const { headerSearchType } = useHeaderSearchTypeSelection();
  const suggestions = useSuggestions(headerSearchType);
  return (
    <Root>
      <MenuTitleSmall>Example searches</MenuTitleSmall>
      {suggestions.map(item => {
        return (
          <StyledItem key={item.id}>
            <div>{getOptionIcon(item.type)}</div>
            <ItemLink to={getModelEntityUrl(item.type, item.id, item.name)} onClick={props.close}>
              {item.name}
            </ItemLink>
          </StyledItem>
        );
      })}
    </Root>
  );
}

const StyledItem = styled(Item)`
  display: flex;
  align-items: center;
  gap: 8px;
`;
